export function convertAmountToWords(amount) {
  const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
      "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
      "Seventeen", "Eighteen", "Nineteen"
  ];

  const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const numToWords = (n) => {
      let str = "";
      if (n > 19) {
          str += tens[Math.floor(n / 10)] + " ";
          n %= 10;
      }
      if (n > 0) {
          str += ones[n] + " ";
      }
      return str;
  };

  const convertToIndianWords = (num) => {
      if (num === 0) return "Zero";

      let result = "";

      const crore = Math.floor(num / 10000000);
      if (crore > 0) {
          result += numToWords(crore) + "Crore ";
          num %= 10000000;
      }

      const lakh = Math.floor(num / 100000);
      if (lakh > 0) {
          result += numToWords(lakh) + "Lakh ";
          num %= 100000;
      }

      const thousand = Math.floor(num / 1000);
      if (thousand > 0) {
          result += numToWords(thousand) + "Thousand ";
          num %= 1000;
      }

      const hundred = Math.floor(num / 100);
      if (hundred > 0) {
          result += ones[hundred] + " Hundred ";
          num %= 100;
      }

      if (num > 0 && result !== "") {
          result += "and ";
      }

      result += numToWords(num);
      return result.trim();
  };

  const [integerPart, decimalPart] = amount.toString().split(".");

  let integerWords = convertToIndianWords(parseInt(integerPart));

  let result = integerWords;

  if (decimalPart && parseInt(decimalPart) > 0) {
      let decimalWords = convertToIndianWords(parseInt(decimalPart)) + " Paise";
      result += " and " + decimalWords;
  }

  return result + " Only";
}


export const calculateTotalGstAmount = (gstArray)=>{
    const gstId = gstArray;
    if (gstId && gstId.length > 0) {
      const totals = gstId.reduce(
        (acc, item) => {
          const { baseAmount, gstAmount } = item?._id;
          const { sgst, igst, cgst } = gstAmount;

          acc.baseAmount += parseFloat(baseAmount || 0);
          acc.cgst += parseFloat(cgst || 0);
          acc.sgst += parseFloat(sgst || 0);
          acc.igst += parseFloat(igst || 0);

          return acc;
        },
        {
          baseAmount: 0,
          cgst: 0,
          sgst: 0,
          igst: 0,
        }
      );

      totals.gst = totals.cgst + totals.sgst + totals.igst;
      return totals
    }
}

export const createAmountID = (poNumberObj,index) => {
    if (poNumberObj) {
      return `${poNumberObj?.prfx}${
        poNumberObj?.m > 9
          ? poNumberObj?.m
          : "0" + parseInt(poNumberObj?.m)
      }${`${poNumberObj?.y}`?.slice(2, 4)}-${
        poNumberObj?.n > 9 ? poNumberObj?.n : "0" + poNumberObj?.n
      }-${
        index > 9
          ? index
          : "0" + index
      }`;
    } else {
      return "";
    }
  };